import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import * as yup from 'yup';

const ArquivoRetornoSchema = yup.object().shape({
  arquivoNome: yup
    .string()
    .nullable()
    .required(mensagemCampoObrigatorio('o arquivo')),
});

export default ArquivoRetornoSchema;
